<ChapterNav params="{params}" segment="regeln" />
{#if ch}
  <div class="section" id="chapter">
    <div class="container pt-5">
      <div class="has-text-centered mt-5 mb-5">
        <h2 class="is-size-3">
          {@html ch.title}
        </h2>
        <h3 class="is-size-4">Die Regeln</h3>
      </div>
    </div>

    <div class="container mt-4 mb-5-desktop {videoPlayed ? '' : 'disabled'}">
      {#if !videoPlayed}
        <div class="columns">
          <article
            class="disabled-notice column message is-warning is-three-fifths-desktop is-offset-one-fifth-desktop"
          >
            <div class="message-header">
              <p>Hinweis</p>
            </div>
            <div class="message-body">
              Du kannst die Textlektion erst lesen, nachdem du das Video dieser
              Lektion angesehen hast.
            </div>
            <div class="message-footer has-text-centered">
              <button
                class="button"
                on:click="{() => push('/platzreife/' + ch.slug + '/video')}"
              >
                <span>Zum Video</span>
              </button>
            </div>
          </article>
        </div>
      {/if}

      <div class="chapter-text has-text-centered">
        {#if !allRulesRead}
          <h3 class="is-size-4">
            Jetzt lese dir bitte die Details dazu durch:
          </h3>
        {/if}

        <div class="tabs is-centered is-medium mt-6 mb-6">
          <ul>
            {#each ch.rules as _, index}
              <li class="{activeRule == index ? 'is-active' : ''}">
                <a
                  on:click="{() => setActiveRule(index)}"
                  class="{rulesRead[index] ? 'has-text-success' : ''}"
                >{index + 1}. Teil</a>
              </li>
            {/each}
          </ul>
        </div>

        <div class="columns">
          {#each ch.rules as data, index}
            {#if activeRule == index}
              <div
                data-tab-index="{index}"
                class="column is-three-fifths-desktop is-offset-one-fifth-desktop"
              >
                {#each data.regeln as rule, rIndex}
                  <div class="rule-single mb-5">
                    <p class="has-text-left mb-2">
                      <strong class="is-size-6">{rule.title}</strong>
                    </p>
                    <div class="content has-text-left">
                      {@html rule.text}
                    </div>
                  </div>
                {/each}
              </div>
            {/if}
          {/each}
        </div>
      </div>

      <div class="columns">
        <div
          class=" column is-three-fifths-desktop is-offset-one-fifth-desktop"
        >
          <div class="media px-4 py-4 has-background-success-light mt-5">
            <span class="media-left"><Icon
                icon="check"
                size="large"
                iconSize="fa-3x"
              /></span>
            {#if allRulesRead}
              <div class="media-content ml-5">
                Soweit alle Lektionen zu:
                {ch.title}
                <br />Du hast alles verstanden? Dann kannst du jetzt die Prüfung
                zu diesem Regelbereich ablegen.
              </div>
              <button
                class="button is-success mt-3 mb-3"
                on:click="{() => push('/platzreife/' + ch.slug + '/pruefung')}"
              >Prüfung</button>
            {:else}
              <div class="media-content ml-5 mt-3">
                Ende
                {activeRule + 1}. Teil
              </div>
              <button
                class="button is-success mt-3 mb-3"
                on:click="{nextRuleCard}"
              >Zum
                {activeRule + 2}. Teil</button>
            {/if}
          </div>
        </div>
      </div>
    </div>
  </div>
{/if}

<script>
import { onMount } from "svelte";
import { currentChapter, userProgress } from "./stores";
import { ChapterService } from "./services/chapter.service";
import Icon from "./Icon.svelte";
import ChapterNav from "./ChapterNav.svelte";
import { push } from "svelte-spa-router";
import * as animateScroll from "svelte-scrollto";
import { chaptersSvc } from "./services";
import { progressSvc } from "./services/progress.service";

let ch, up, videoPlayed, activeRule, allRulesRead, chapterSvc, rulesRead;
export let params = {};

const setActiveRule = (index) => {
  activeRule = index;
  chapterSvc.setRuleRead(index);
};

const nextRuleCard = () => {
  animateScroll.scrollTo({
    element: ".tabs",
    offset: -150,
    duration: 250,
  });
  setActiveRule(activeRule + 1);
};

const initData = () => {
  if (!ch || !up) {
    return;
  }
  videoPlayed = progressSvc.hasVideoPlayed();
  allRulesRead = progressSvc.hasAllRulesRead();
  rulesRead = progressSvc.getReadRules();
};

onMount(() => {
  currentChapter.subscribe((value) => {
    if (value == undefined) {
      return;
    }
    ch = value;
    chapterSvc = new ChapterService(ch);

    setActiveRule(chapterSvc.getInitialActiveRule());
    if (allRulesRead && chaptersSvc.getChapterStatus(ch.slug) !== "finished") {
      chaptersSvc.setChapterStatus(ch.slug, "finished");
    }

    initData();
  });
  userProgress.subscribe((data) => {
    up = data;
    initData();
  });
});
</script>

<style type="text/scss">
@import "./scss/video-iframe";
.chapter-text {
  transition: all 0.3s ease;
  position: relative;
}
.disabled-notice {
  display: none;
}
.disabled {
  .chapter-text {
    pointer-events: none;
    opacity: 0.2;
    filter: blur(3px);
    max-height: 500px;
    overflow: hidden;
  }
  .disabled-notice {
    display: block;
  }
}
</style>
